import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {IOSFullscreenModule} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {IOSFullscreenModuleStates} from '@gongxigames/framework/slot/modules/iOSFullscreen/IOSFullscreenModule';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class IdleState extends ModuleState<null, IOSFullscreenModule, GlobalEventsMapForBackwardCompatibility> {
    public onEnterState(): void {
        this.module.hideScroll();
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        strictUiEmitter.on('UI.menu.menuBarClosed', this.onStrictGoToNextState.bind(this));
        this.setEventHandler('Autoplay.HIDE_OPTIONS_POPUP', this.goToNextState.bind(this));
    }

    protected onStrictGoToNextState(): void {
        if (this.module.currentState?.name === this.name) {
            this.goToNextState();
        }
    }

    protected goToNextState(): void {
        if (this.module.isFullScreen()) {
            this.module.gotoState(IOSFullscreenModuleStates.Fullscreen);
        } else {
            this.module.gotoState(IOSFullscreenModuleStates.NotFullScreen);
        }
    }
}
